import _classPrivateFieldInitSpec from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/esnext.iterator.map.js";
import JsonMapper from "../helpers/JsonMapper";
import StripeCustomData from "./StripeCustomData";
import Store from "../domain/Store";
var _attributes = /*#__PURE__*/new WeakMap();
export default class Stripe extends JsonMapper {
  constructor(data) {
    super(data);
    _classPrivateFieldInitSpec(this, _attributes, {
      [Stripe.id_attribute_name]: null,
      [Stripe.name_attribute_name]: null,
      [Stripe.mode_attribute_name]: null,
      [Stripe.live_public_key_attribute_name]: null,
      [Stripe.live_private_key_attribute_name]: null,
      [Stripe.test_public_key_attribute_name]: null,
      [Stripe.test_private_key_attribute_name]: null,
      [Stripe.is_active_attribute_name]: null,
      [Stripe.custom_data_attribute_name]: StripeCustomData,
      [Stripe.domain_attribute_name]: Store
    });
    this.map(data, _classPrivateFieldGet(_attributes, this));
  }
  static getIdAttributeName() {
    return this.id_attribute_name;
  }
  static getNameAttributeName() {
    return this.name_attribute_name;
  }
  static getModeAttributeName() {
    return this.mode_attribute_name;
  }
  static getLivePublicKeyAttributeName() {
    return this.live_public_key_attribute_name;
  }
  static getLivePrivateKeyAttributeName() {
    return this.live_private_key_attribute_name;
  }
  static getTestPublicKeyAttributeName() {
    return this.test_public_key_attribute_name;
  }
  static getTestPrivateKeyAttributeName() {
    return this.test_private_key_attribute_name;
  }
  static getStatusAttributeName() {
    return this.is_active_attribute_name;
  }
  static getCustomDataAttributeName() {
    return this.custom_data_attribute_name;
  }
  getId() {
    return this.getAttribute(Stripe.getIdAttributeName());
  }
}
_defineProperty(Stripe, "LIVE_MODE", 'live');
_defineProperty(Stripe, "TEST_MODE", 'test');
_defineProperty(Stripe, "id_attribute_name", 'id');
_defineProperty(Stripe, "name_attribute_name", 'name');
_defineProperty(Stripe, "mode_attribute_name", 'mode');
_defineProperty(Stripe, "live_public_key_attribute_name", 'live_public_key');
_defineProperty(Stripe, "live_private_key_attribute_name", 'live_private_key');
_defineProperty(Stripe, "test_public_key_attribute_name", 'test_public_key');
_defineProperty(Stripe, "test_private_key_attribute_name", 'test_private_key');
_defineProperty(Stripe, "is_active_attribute_name", 'is_active');
_defineProperty(Stripe, "custom_data_attribute_name", 'custom_data');
_defineProperty(Stripe, "domain_attribute_name", 'domain');